import { IDangKyAnImportRequest } from "../../../models/request/thuc-don/IDangKyAnImportRequest";
import { IDangKyAnReponse } from "../../../models/response/thuc-don/IDangKyAnReponse";
import { IFoDangKyAnHocSinh, IFoDangKyAnHocSinhVm } from "../../../models/response/thuc-don/IFoDangKyAnHocSinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDangKyAnHocSinhDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoDangKyAnHocSinhVm[],
    LOAD_ERROR: "",
    LOAD_BY_COSO_NAMHOC_START: { dm_coso_id: 0, nam_hoc: "" },
    LOAD_BY_COSO_NAMHOC_SUCCESS: [] as IFoDangKyAnHocSinhVm[],
    LOAD_BY_COSO_NAMHOC_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoDangKyAnHocSinh | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoDangKyAnHocSinh,
    SAVE_SUCCESS: {} as IFoDangKyAnHocSinh,
    SAVE_ERROR: "",
    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,
    SAVE_IMPORT_START: {} as IDangKyAnImportRequest,
    SAVE_IMPORT_SUCCESS: {} as IDangKyAnReponse,
    SAVE_IMPORT_ERROR: "",
};

export const eFoDangKyAnHocSinhActionTypeIds = generateActionTypeIds(objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH");

export type IFoDangKyAnHocSinhActionTypes = IGenericActionType<typeof objDangKyAnHocSinhDefine, "DANG_KY_AN_HOC_SINH">;
